import { TestRes } from '../response/test.response';
import httpClient from '../util/http-client';

export const TestFeedbackService = {
  save: async (
    description: string,
    rating: number,
    testId: string,
  ): Promise<(TestRes | never)[]> => {
    let data;
    let err;
    try {
      const res = await httpClient.post(`/test-feedback`, {
        description: description,
        testId: testId,
        rating: rating,
      });
      data = res.data;
    } catch (error: any) {
      err = error;
    }
    return [data?.data, err];
  },
};
